import React, { useState, useEffect } from "react";
import "./pactometroCheck.scss";
import { PropTypes } from "prop-types";

const PactometroCheck = ({ data, onChange, selecteds = [] }) => {
  const [selectedsId, setSelectedsId] = useState(selecteds);

  const onchange = id => {
    let selecteds = [...selectedsId];
    if (selectedsId.some(select => select === id)) {
      selecteds = selecteds.filter(item => item !== id);
    } else {
      selecteds = [...selecteds, id];
    }

    setSelectedsId(selecteds);

    onChange(selecteds);
  };

  useEffect(() => {
    setSelectedsId(selecteds);
  }, [selecteds]);

  return (
    <div className="pactos">
      {data &&
        data.map(item => (
          <div
            key={JSON.stringify(item)}
            className="row-pactometro"
            role="presentation"
            onClick={() => onchange(item.id)}
          >
            <input
              type="checkbox"
              onChange={() => {}}
              checked={selectedsId.some(select => select === item.id)}
            />
            {/* eslint-disable-next-line */}
            <label style={{ borderLeft: `10px solid ${item.partyColor} ` }}>
              <span>{item.partyAcronym}</span>
              <p>
                {" "}
                {/* ({item.seats} escaños - {item.votesPercent}% votos) */}
                {item.seats} escaños
              </p>
            </label>
          </div>
        ))}
    </div>
  );
};

PactometroCheck.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      partyAcronym: PropTypes.string.isRequired,
      seats: PropTypes.number.isRequired,
      partyColor: PropTypes.string.isRequired,
      votes: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired
};

export default PactometroCheck;
